module.exports = __webpack_public_path__ + "img/img1.f82650ec.png";